import { startDesignDnaFigmaPublishDemoStreamLoop } from './designDnaFigmaPublishDemoStreamLoop.js'

/** @param {import('./runDesignDnaDemoStream.js').DesignDnaStreamCtx} ctx */
export function runDesignDnaFigmaPublishDemoStream(ctx) {
  startDesignDnaFigmaPublishDemoStreamLoop(ctx)
}
